"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Alert;
Object.defineProperty(exports, "AlertProps", {
  enumerable: true,
  get: function get() {
    return _types.AlertProps;
  }
});

var _react = _interopRequireWildcard(require("react"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _StyledButton = _interopRequireDefault(require("./StyledButton"));

var _Container = _interopRequireDefault(require("./Container"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Typography = require("../Typography");

var _intents = _interopRequireDefault(require("./intents"));

var _types = require("./types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function Alert(_ref) {
  var ariaLabel = _ref['aria-label'],
      children = _ref.children,
      description = _ref.description,
      dismissable = _ref.dismissable,
      icon = _ref.icon,
      _ref$intent = _ref.intent,
      intent = _ref$intent === void 0 ? 'information' : _ref$intent,
      onDismissClick = _ref.onDismissClick,
      title = _ref.title,
      tooltipText = _ref.tooltipText;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var translate = (0, _useTranslations.default)();
  var borderColor = (0, _toColorString.default)(_intents.default[intent].borderColor);
  var Icon = icon || _intents.default[intent].icon;

  var handleClick = function handleClick() {
    setOpen(false);
    if (onDismissClick) onDismissClick();
  };

  if (!open) {
    return _react.default.createElement(_react.default.Fragment, null);
  }

  return _react.default.createElement(_Container.default, {
    flex: 1,
    paddingLeft: 1.5,
    paddingRight: 1.6,
    paddingTop: 1.3,
    paddingBottom: 1.1,
    intent: intent
  }, _react.default.createElement(Icon, {
    color: borderColor
  }), _react.default.createElement(_Flex.default, {
    flexDirection: "column",
    marginLeft: 1,
    flex: 1
  }, _react.default.createElement(_Flex.default, {
    alignItems: "center",
    flex: 1
  }, _react.default.createElement(_Typography.P, {
    weight: "semibold",
    marginRight: 1
  }, title), dismissable && _react.default.createElement(_Tooltip.default, {
    placement: "auto",
    target: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement(_StyledButton.default, {
      variant: "ghost",
      icon: _Times.default,
      onClick: handleClick,
      "aria-label": translate(ariaLabel, 'alert.closeAlert')
    })
  }, translate(tooltipText, 'alert.close'))), _react.default.createElement(_Typography.P, {
    size: "small"
  }, children || description)));
}

Alert.propTypes = _types.propTypes;
Alert.defaultProps = _types.defaultProps;